import { MetaKeyWithCounter } from '@playq/services-beetle';

import { MetaWithCounterType } from './types';

export const sortMetaByCount = (a: MetaWithCounterType, b: MetaWithCounterType) => {
  if (a.count !== undefined && b.count === undefined) {
    return -1;
  }
  if (b.count !== undefined && a.count === undefined) {
    return 1;
  }
  if (b.count !== undefined && a.count !== undefined) {
    return b.count - a.count;
  }
  return 0;
};

export const setChipLabel = ({ key, value }: MetaWithCounterType) => `${key}: ${value || 'undefined'}`;

export const mapMetaToTableMetaWithCounter = (meta: { [key: string]: string }, metaWithCounter: MetaKeyWithCounter[]) =>
  Object.keys(meta).map((key) => ({
    key,
    value: meta[key],
    count: metaWithCounter.find(({ key: filterKey }) => filterKey === key)?.count,
  }));
